export default __webpack_public_path__ + "static/media/featureBgMb.a76d993a.png";